import * as React from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import { Loader } from 'semantic-ui-react';

import { AlphaDetailsSummaryColumns } from '../../shared/data/AlphaDetailsSummaryColumns';
import { SummaryLine } from './Summary/SummaryStatus';
import { TypeStage } from './Summary/types';

interface AlphaRegionSummaryProps {
  modifiers?: string[];
  typeStage: TypeStage;
  alpha: any;
  region: string;
  intl: IntlShape;
}

function AlphaRegionSummaryIntl({ alpha, region, typeStage }: AlphaRegionSummaryProps) {
  const tableHeader = AlphaDetailsSummaryColumns[typeStage];
  const regionKey = 'glb' + region[0].toUpperCase() + region.slice(1);

  const alphaRecords = alpha && alpha.getIn([typeStage, regionKey]);
  const tableInfo = alphaRecords && alphaRecords.toJS();

  if (alpha && !tableInfo) {
    return null;
  } else {
    return (
      <div key={region}>
        <div className="summary__header">
          <div className="summary__subtitle">{region.toUpperCase()}</div>
        </div>
        {!tableInfo ? (
          <div className="loader">
            <Loader active={true} inline="centered" size="massive" />
          </div>
        ) : (
          <SummaryLine
            tableHeader={tableHeader.summary}
            tableInfo={tableInfo}
            typeStage={typeStage}
            showAccordionArrow={false}
            isTitleHidden={true}
          />
        )}
      </div>
    );
  }
}

export default injectIntl(AlphaRegionSummaryIntl);
